<template>
  <nav class="navbar">
    <div class="logo">
      <img src="../assets/logo.png" alt="奇点桌球" />
    </div>

    <!-- hamburger icon for mobile -->
    <div class="menu-toggle" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <div class="nav-links" :class="{ open: isOpen }">
      <router-link to="/" class="nav-item">首页</router-link>
      <router-link to="/products" class="nav-item">产品中心</router-link>
      <router-link to="/solutions" class="nav-item">解决方案</router-link>
      <router-link to="/technology" class="nav-item">技术优势</router-link>
      <router-link to="/cases" class="nav-item">用户案例</router-link>
      <router-link to="/about" class="nav-item">关于我们</router-link>
    </div>
    <div class="contact-btn">
      <button class="consult-btn">立即咨询</button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    }
  }
}
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 5%;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.logo img {
  height: 60px;
}

.nav-links {
  display: flex;
  gap: 2rem;
  margin-left: auto;
  margin-right: 3rem;
}

.nav-item {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  transition: color 0.3s;
}

.nav-item:hover {
  color: #ff0000;
}

.consult-btn {
  background-color: #ff0000;
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.consult-btn:hover {
  background-color: #e60000;
}

/* 移动端优化 */
.menu-toggle {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 4px;
}

.menu-toggle span {
  width: 25px;
  height: 3px;
  background-color: #333;
  transition: all 0.3s;
}

@media (max-width: 768px) {
  .navbar {
    padding: 0.5rem 2%;
  }

  .menu-toggle {
    display: flex;
  }

  .logo img {
    height: 40px;
  }

  .nav-links {
    position: absolute;
    top: 64px;
    left: 0;
    right: 0;
    background: #fff;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 1rem 0;
    margin-right: 0;
    display: none;
  }

  .nav-links.open {
    display: flex;
  }

  .nav-item {
    font-size: 14px;
  }

  .consult-btn {
    padding: 0.4rem 1rem;
    font-size: 14px;
  }

  .contact-btn {
    display: none;
  }
}
</style>